import { useCallback, useEffect, useState, useSyncExternalStore } from "react";

let isHeroVisible = false;
const subscribers = new Set<() => void>();

function setHeroVisible(value: boolean) {
  if (isHeroVisible === value) return;
  isHeroVisible = value;
  subscribers.forEach((cb) => cb());
}

function subscribe(cb: () => void) {
  subscribers.add(cb);
  return () => {
    subscribers.delete(cb);
  };
}

export function useHeroVisible(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => isHeroVisible,
    () => false,
  );
}

export function useHeroSentinel() {
  const [node, setNode] = useState<HTMLElement | null>(null);

  const ref = useCallback((el: HTMLElement | null) => {
    setNode(el);
  }, []);

  useEffect(() => {
    if (!node || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHeroVisible(entry.isIntersecting);
      },
      { rootMargin: "-68px 0px 0px 0px", threshold: 0 },
    );
    observer.observe(node);
    setHeroVisible(true);

    return () => {
      observer.disconnect();
      setHeroVisible(false);
    };
  }, [node]);

  return ref;
}
